<template>
    <!-- 
        Export data to excel:

        required input: 
            cols            : Array of column descriptions  - {
                                                                "Name"      : "Col1",       // Column header name
                                                                "Type"      : "Text"        // Column type (Text/Date/Number)
                                                                "Field"     : "huis_code"   // Field name of value in data object.
                                                              }
            data            : Array of data objects         -  
        optional input:
            name            : String                        - Name of export, defaults to "export.xlsx"
            sheet           : String                        - Name of sheet in export, defaults to "Sheet 1"
            tooltip         : String                        - Tooltip for button, defaults to "Export data to excel"
    -->
    <span class="ml-1">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-spacer/>
                <v-icon v-bind="attrs" v-on="on" medium color="green" v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
            </template>
            <span>Export data to Excel</span>
        </v-tooltip>
    </span>
</template>

<script>
    export default { 
        components: {
        },    
        props: {
            cols: {
                type: Array,
                required: true,               
            },
            data: {
                type: Array,
                required: true,               
            },  
            name: {
                type: String,
                required: false,  
                default: "export.xlsx",
            },
            sheet: {
                type: String,
                required: false,
                default: "Sheet 1",
            },          
            tooltip: {
                type: String,
                required: false,  
                default: "Export data to Excel",             
            },        
        },
        data() {
            return {
            }
        },  
        methods: {
            exportDataToExcel() {
                let excel = [];  // Array of rows
                for (let row_nr = 0; row_nr < this.data.length; row_nr++) {                
                    
                    let row = new Object();
                    for (let col_nr = 0; col_nr < this.cols.length; col_nr++) { 
                        switch (this.cols[col_nr].Type) {
                            case "Date":
                                row[this.cols[col_nr].Name] = new Date(this.data[row_nr][this.cols[col_nr].Field]);
                                break;
                            case "Number":
                                row[this.cols[col_nr].Name] = +this.data[row_nr][this.cols[col_nr].Field];
                                break;
                            default:
                                row[this.cols[col_nr].Name] = this.data[row_nr][this.cols[col_nr].Field];
                        }
                    } 
                    excel.push(row);
                }
                var XLSX = require("xlsx");
                var ws = XLSX.utils.json_to_sheet(excel);
                var wb = XLSX.utils.book_new();
                
            
                XLSX.utils.book_append_sheet(wb, ws, this.sheet);
                XLSX.writeFile(wb, this.name);
            },
        },
    }

</script>

<style scoped>
    .xlsx {
        cursor: pointer;
    }
</style>